import { render, staticRenderFns } from "./FormEditView.vue?vue&type=template&id=2b2d6788&scoped=true&"
import script from "./FormEditView.vue?vue&type=script&lang=ts&"
export * from "./FormEditView.vue?vue&type=script&lang=ts&"
import style0 from "./FormEditView.vue?vue&type=style&index=0&id=2b2d6788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d6788",
  null
  
)

export default component.exports